<template>
    <div class="contact">
        <div class="title">联系我们</div>
        <div class="box">
            <div class="wechat">
                <div class="imgbg">
                    <img src="../../assets/wechat.svg" class="wc">
                    <img src="../../assets/gongzhonghao.png" class="gongzhonghao">
                </div>

                <div class="txt">微信公众号</div>
            </div>
            <div class="customer">
                <div class="imgbg">
                    <img src="../../assets/people.svg" class="wc">
                    <img src="../../assets/kefu.png" class="kefu">
                </div>
                <div class="txt">官方客服</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "contact",
    data() {
        return {}
    },
    components: {},
    methods: {}
}
</script>

<style lang="scss" scoped>
.contact {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #fff;
    width: 100%;
    .title {
        color: #222222;
        font-size: 50px;
        padding: 50px;
    }

    .box {
        display: flex;
        justify-content: center;
        align-items: center;

        .wechat {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin-right: 120px;
            cursor: pointer;

            &:hover {
                .gongzhonghao {
                    transition: .5s;
                    transform: scale(1);
                    width:250px;
                }

                .wc {
                    transform: scale(0);
                }

                .imgbg {
                    background: transparent;
                }
            }

            .gongzhonghao {
                transform: scale(0);
                position: absolute;
            }

            .imgbg {
                background: #EFF5FF;
                border-radius: 50%;
                width: 250px;
                height: 250px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;

                img {
                    width: 158px;
                }
            }

            .txt {
                color: #222222;
                font-size: 30px;
                padding-top: 30px;
            }
        }

        .customer {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            cursor: pointer;
            position: relative;

            &:hover {
                .kefu {
                    transition: .5s;
                    transform: scale(1);
                    width:250px;
                }

                .wc {
                    transform: scale(0);
                }

                .imgbg {
                    background: transparent;
                }
            }

            .kefu {
                transform: scale(0);
                position: absolute;
            }

            .imgbg {
                background: #EFF5FF;
                border-radius: 50%;
                width: 250px;
                height: 250px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 158px;
                }
            }

            .txt {
                color: #222222;
                font-size: 30px;
                padding-top: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/contact/index.vue